import { useConfigStore } from '@/store/config.store';
import { Wedding3DWorld } from '@/littleWedding/Wedding3DWorld';
import { storeToRefs } from 'pinia';

function useAnimationControl() {
    const { isAnimated } = storeToRefs(useConfigStore());

    function startAnimation() {
        isAnimated.value = true;
        Wedding3DWorld.animateCamera(isAnimated.value);
    }

    function stopAnimation() {
        isAnimated.value = false;
        Wedding3DWorld.animateCamera(isAnimated.value);
    }

    function toggleAnimation() {
        if (isAnimated.value) {
            stopAnimation();
        } else {
            startAnimation();
        }
    }

    return {
        toggleAnimation,
        startAnimation,
        stopAnimation,
        isAnimated,
    };
}

export { useAnimationControl };
